import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-module-header',
  standalone:false,
  templateUrl: './module-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './module-header.component.css'
})
export class ModuleHeaderComponent {
  @Input() title: string = '';
  @Input() icon: string = '';

  constructor() {
    if( !this.title ) this.title = 'Module Name';
    if( !this.icon ) this.icon = 'extension';
  }
}
